import React from 'react';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';
import Box from '@components/layout/box';
import Typography from '@components/basics/typography';
import LyricsCtrl from '@webapp/controllers/track/lyrics';
import ISRCCtrl from '@webapp/controllers/track/isrc-code';
import TrackLanguageCtrl from '@webapp/controllers/track/language';
import TrackTypeCtrl from '@webapp/controllers/track/track-type';
import TrackVersionCtrl from '@webapp/controllers/track/version/index';
import SongTitleCtrl from '@webapp/controllers/release/song-title-input';
import ExplicitContentCtrl from '@webapp/controllers/track/explicit-content';
import InstantGratificationCtrl from '@webapp/controllers/track/instant-gratification/index';
import Flex from '@components/layout/flex';
import { ReleaseType } from '@common/types/release/release-type';
import { connect } from 'react-redux';
import { getTrackIdFromPath } from '@webapp/utils/tracks/get-track-id-from-url-path';
import AppState from '@webapp/store/state';

const mapStateToProps = (state: AppState) => {
  const activeTrackId = getTrackIdFromPath(state);
  const currentTrack = state.tracks.tracks[activeTrackId];
  const isSong = currentTrack?.type === 'song';

  return {
    releaseType: state.release.release?.type,
    releaseId: state.release.release?.id as string,
    isrcExists: currentTrack?.isrcExists,
    trackId: activeTrackId,
    isSong: isSong,
  };
};

type GeneralTrackInfoProps = {
  releaseType?: ReleaseType;
  releaseId: string;
  trackId: string;
  validateForm: boolean;
  isSong: boolean;
  isrcExists?: boolean;
};

export const GeneralTrackInfo = ({
  releaseType,
  releaseId,
  trackId,
  validateForm,
  isSong,
  isrcExists,
}: GeneralTrackInfoProps) => {
  return (
    <Box noBorderBottom>
      <Typography className="mb-20" type="big-title" customFont="medium">
        <Translate
          id={`RELEASE.TRACK_INFO.TITLE.${
            releaseType === 'single' ? 'SINGLE' : 'ALBUM'
          }`}
        />
      </Typography>

      <Wrapper gap={10}>
        <SongTitleCtrl
          label={<Translate id="RELEASE.TRACK_INFO.TITLE.TRACK.NAME" />}
          releaseId={releaseId}
          trackId={trackId}
          validate={validateForm}
          locked={isrcExists}
        />

        <TrackVersionCtrl
          id="trackVersionDropdown"
          className="mb-20"
          trackId={trackId}
          locked={isrcExists}
        />

        <Flex className="mb-20" flexDirection="column">
          <TrackTypeCtrl
            id="instrumentalDropdown"
            validate={validateForm}
            trackId={trackId}
            locked={isrcExists}
          />

          {isSong && (
            <>
              <ExplicitContentCtrl
                id="explicitDropdown"
                className="mt-20 mb-20"
                trackId={trackId}
                validate={validateForm}
                releaseId={releaseId}
              />

              <LyricsCtrl
                className="mb-20"
                trackId={trackId}
              />

              <TrackLanguageCtrl
                id="languageDropdown"
                trackId={trackId}
                validate={validateForm}
                releaseId={releaseId}
              />
            </>
          )}
        </Flex>

        <ISRCCtrl trackId={trackId} validate={validateForm} />

        <InstantGratificationCtrl trackId={trackId} />
      </Wrapper>
    </Box>
  );
};

export default connect(mapStateToProps)(GeneralTrackInfo);

const Wrapper = styled.div<{ gap?: number }>`
  display: grid;
  grid-gap: ${({ gap }) => (gap ? `${gap}px` : '3px')};
`;
